import { useTranslation } from '@humans-sdk/core/utils/locales';

import { Button, Text } from '@components';
import { ENTERPRISE_LOCALE_NAME, URL_HELPDESK_ACCESS } from '@constants';
import { NoAccessIcon } from '@icons';

import s from './NoAccess.module.scss';

const NoAccess = () => {
    const { t } = useTranslation(ENTERPRISE_LOCALE_NAME);

    return (
        <div className={s.root}>
            <NoAccessIcon classes={{ root: s.icon }} />
            <Text variant="h1" className={s.caption}>
                {t('reason')}
            </Text>
            <Text variant="body1" className={s.text}>
                {t('comment')}
            </Text>
            <Button size="large" variant="contained" color="primary" target="_blank" href={URL_HELPDESK_ACCESS}>
                {t('buttonLabel')}
            </Button>
        </div>
    );
};

export default NoAccess;
